// Shared API configuration

let baseURL = '';
const host = window.location.hostname;
const port = window.location.port;

if ((host === 'localhost' || host === '127.0.0.1') && (port === '5173')) {
  baseURL = 'http://localhost:4242/';
} else {
  // In production or when served from the backend, use the current origin
  baseURL = window.location.origin + '/';
}

const CONTENT_TYPE = 'application/json';

const defaultConfig = {
  baseURL,
  headers: {
    'Content-Type': CONTENT_TYPE,
    'Accept': CONTENT_TYPE
  }
};

// API routes configuration
const apiRoutes = {
  // Auth routes
  auth: {
    login: { path: '/auth/local/login', method: 'POST', authRequired: false },
    googleLogin: { path: '/auth/google/login', method: 'POST', authRequired: false },
    register: { path: '/auth/local/register', method: 'POST', authRequired: false },
    refreshToken: { path: '/api/auth/useRefreshToken', method: 'POST', authRequired: false },
    // authRequired: false so 401 on logout does not trigger token refresh (we clear tokens before calling)
    logout: { path: '/api/auth/logout', method: 'POST', authRequired: false },
    logoutAll: { path: '/api/auth/logoutAll', method: 'POST', authRequired: false },
    verifyEmail: { path: '/api/auth/verifyEmail', method: 'POST', authRequired: false },
    sendVerifyEmailLink: { path: '/api/auth/sendVerifyEmailLink', method: 'POST', authRequired: true },
    sendForgotPasswordEmailLink: { path: '/api/auth/sendForgotPasswordEmailLink', method: 'POST', authRequired: false },
    forgotPasswordEmailLinkReset: { path: '/api/auth/forgotPasswordEmailLinkReset', method: 'POST', authRequired: false },
    verifyResetCode: { path: '/api/auth/verifyResetCode', method: 'POST', authRequired: false },
    resetPassword: { path: '/api/auth/resetPassword', method: 'POST', authRequired: false },
    resetPasswordForce: { path: '/api/auth/resetPasswordForce', method: 'POST', authRequired: true },
  },

  // Blog routes
  blogs: {
    // Public routes
    getPublicBlogs: { path: '/api/pub/blogs/GetAllSummary', method: 'GET', authRequired: false },
    getPublicBlog: { path: '/api/pub/blogs/:id', method: 'GET', authRequired: false },

    // Admin routes
    getAdminBlogs: { path: '/api/system/Blog', method: 'GET', authRequired: true },
    getAdminBlog: { path: '/api/system/Blog/:id', method: 'GET', authRequired: true },
    createBlog: { path: '/api/system/Blog', method: 'POST', authRequired: true },
    updateBlog: { path: '/api/system/Blog/:id', method: 'PUT', authRequired: true },
    deleteBlog: { path: '/api/system/Blog/:id', method: 'DELETE', authRequired: true },
  },

  // Payment routes
  payment: {
    createOrder: { path: '/api/payment/create-order', method: 'POST', authRequired: true },
    createSubscriptionOrder: { path: '/api/payment/create-subscription-order', method: 'POST', authRequired: true },
    getOrderDetails: { path: '/api/payment/order/:id', method: 'GET', authRequired: true },
    cancelOrder: { path: '/api/payment/:id/cancel-order', method: 'POST', authRequired: true },
    cancelSubscription: { path: '/api/payment/cancel-subscription/:id', method: 'POST', authRequired: true },
    getSubscriptionDetails: { path: '/api/payment/subscription/:id', method: 'GET', authRequired: true },
    pauseSubscription: { path: '/api/payment/pause-subscription/:id', method: 'POST', authRequired: true },
    resumeSubscription: { path: '/api/payment/resume-subscription/:id', method: 'POST', authRequired: true },
  },

  // Orders routes
  orders: {
    fetchOrders: { path: '/api/orders/', method: 'GET', authRequired: true },
    fetchOrderById: { path: '/api/orders/:id', method: 'GET', authRequired: true },
  },

  // Products routes
  products: {
    fetchAll: { path: '/api/products/GetAll', method: 'GET', authRequired: true },
    fetchById: { path: '/api/products/:id', method: 'GET', authRequired: true },
    fetchWithQuery: { path: '/api/products/GetWhere', method: 'GET', authRequired: true },
  },

  // Table editor routes
  tableEditor: {
    fetchData: { path: '/api/:tableType/:tableName', method: 'GET', authRequired: true },
    updateRecord: { path: '/api/:tableType/:tableName/:id', method: 'PUT', authRequired: true },
    createRecord: { path: '/api/:tableType/:tableName', method: 'POST', authRequired: true },
    deleteRecord: { path: '/api/:tableType/:tableName/:id', method: 'DELETE', authRequired: true },
  },

  // Contact form
  contact: {
    submitMessage: { path: '/api/system/ContactMessage/', method: 'POST', authRequired: true },
  },

  // Sync
  sync: {
    syncData: { path: '/api/sync/', method: 'POST', authRequired: true },
  },

  // Admin routes
  admin: {
    isRegistrationEnabled: { path: '/api/admin/settings/is-registration-enabled', method: 'GET', authRequired: false },
    getServerHealth: { path: '/api/admin/server/health', method: 'GET', authRequired: true },
    updateUserRole: { path: '/api/admin/users/:id/role', method: 'PUT', authRequired: true },
    getUserActivityLogs: { path: '/api/admin/users/:id/activity', method: 'GET', authRequired: true },
    cleanupExpiredTokens: { path: '/api/admin/server/cleanupExpiredTokens', method: 'DELETE', authRequired: true },
    cleanupAudio: { path: '/api/admin/server/cleanupAudio', method: 'POST', authRequired: true },
    purgeDeletedUsers: { path: '/api/admin/server/purgeDeletedUsers', method: 'POST', authRequired: true },
    getTestUsers: { path: '/api/admin/server/testUsers', method: 'GET', authRequired: true },
    deleteTestUsers: { path: '/api/admin/server/testUsers/delete', method: 'POST', authRequired: true },
  },

  // Admin settings
  adminSettings: {
    getAllSettings: { path: '/api/admin/settings', method: 'GET', authRequired: true },
    updateSetting: { path: '/api/admin/settings/:key', method: 'PUT', authRequired: true },
    getSettingsByCategory: { path: '/api/admin/settings/category/:category', method: 'GET', authRequired: true },
    getSetting: { path: '/api/admin/settings/:key', method: 'GET', authRequired: true },
    isRegistrationEnabled: { path: '/api/admin/settings/is-registration-enabled', method: 'GET', authRequired: false },
  },

  // Server health
  server: {
    health: { path: '/api/serverHealth', method: 'GET', authRequired: false },
  },

  // Status routes (public endpoints)
  status: {
    registration: { path: '/api/status/registration', method: 'GET', authRequired: false },
  },

  // User assets
  userAssets: {
    getAll: { path: '/api/userAssets/', method: 'GET', authRequired: true },
    getById: { path: '/api/userAssets/file/:id', method: 'GET', authRequired: true },
    upload: { path: '/api/userAssets/upload', method: 'POST', authRequired: true },
    update: { path: '/api/userAssets/:id', method: 'PUT', authRequired: true },
    delete: { path: '/api/userAssets/:id', method: 'DELETE', authRequired: true },
    share: { path: '/api/userAssets/:id/share', method: 'POST', authRequired: true },
    setPublic: { path: '/api/userAssets/:id/public', method: 'PUT', authRequired: true },
    getRootFolders: { path: '/api/userAssets/folders', method: 'GET', authRequired: true },
    getFolderContents: { path: '/api/userAssets/folders/:id', method: 'GET', authRequired: true },
    createFolder: { path: '/api/userAssets/folders', method: 'POST', authRequired: true },
    updateFolder: { path: '/api/userAssets/folders/:id', method: 'PUT', authRequired: true },
    deleteFolder: { path: '/api/userAssets/folders/:id', method: 'DELETE', authRequired: true },
    shareFolder: { path: '/api/userAssets/folders/:id/share', method: 'POST', authRequired: true },
  },

  // User account
  user: {
    exportData: { path: '/api/user/export', method: 'GET', authRequired: true },
    deleteAccount: { path: '/api/user/account/delete', method: 'POST', authRequired: true },
    requestUndelete: { path: '/api/user/account/undelete/request', method: 'POST', authRequired: false },
    undeleteAccount: { path: '/api/user/account/undelete', method: 'POST', authRequired: false },
    getCredits: { path: '/api/user/credits', method: 'GET', authRequired: true },
    purchaseCredits: { path: '/api/user/credits/purchase', method: 'POST', authRequired: true },
    getCreditHistory: { path: '/api/user/credits/history', method: 'GET', authRequired: true },
  },

  // AI services
  ai: {
    getActiveConversations: { path: '/api/ai/conversations/active', method: 'GET', authRequired: true },
    getConversationContext: { path: '/api/ai/conversations/:id/context', method: 'GET', authRequired: true },
    sendChatMessage: { path: '/api/ai/conversations/chat', method: 'POST', authRequired: true },
    clearConversation: { path: '/api/ai/conversations/:id/clear', method: 'POST', authRequired: true },
    archiveConversation: { path: '/api/ai/conversations/:id/archive', method: 'PUT', authRequired: true },
    unarchiveConversation: { path: '/api/ai/conversations/:id/unarchive', method: 'PUT', authRequired: true },
    renameConversation: { path: '/api/ai/conversations/:id/rename', method: 'PUT', authRequired: true },
    deleteConversation: { path: '/api/ai/conversations/:id', method: 'DELETE', authRequired: true },
    convertSpeechToText: { path: '/api/ai/stt', method: 'POST', authRequired: true },
    convertTextToSpeech: { path: '/api/ai/tts', method: 'POST', authRequired: true },
    getArchivedConversations: { path: '/api/ai/conversations/archived', method: 'GET', authRequired: true },
  },

  // AI usage
  aiUsage: {
    getUsageStats: { path: '/api/ai/usage', method: 'GET', authRequired: true },
    getDetailedUsageStats: { path: '/api/ai/usage/:type', method: 'GET', authRequired: true },
    getAllUsageRecords: { path: '/api/manage/aiUsage', method: 'GET', authRequired: true },
    getUserUsage: { path: '/api/manage/aiUsage/user/:id', method: 'GET', authRequired: true },
    deleteUsageRecord: { path: '/api/manage/aiUsage/:id', method: 'DELETE', authRequired: true },
    deleteUserUsageRecords: { path: '/api/manage/aiUsage/user/:id', method: 'DELETE', authRequired: true },
  },

  // Gamification
  gamification: {
    trackActivity: { path: '/api/gamification/activity', method: 'POST', authRequired: true },
    getUserActivities: { path: '/api/gamification/activity/user', method: 'GET', authRequired: true },
    getUserActivitiesById: { path: '/api/gamification/activity/user/:id', method: 'GET', authRequired: true },
    getActivityStats: { path: '/api/gamification/activity/stats', method: 'GET', authRequired: true },
    getActivityStatsById: { path: '/api/gamification/activity/stats/:id', method: 'GET', authRequired: true },
    getAchievements: { path: '/api/gamification/achievements', method: 'GET', authRequired: true },
    getUserAchievements: { path: '/api/gamification/achievements/user', method: 'GET', authRequired: true },
    getUserAchievementsById: { path: '/api/gamification/achievements/user/:id', method: 'GET', authRequired: true },
    checkAchievementProgress: { path: '/api/gamification/achievements/:id/check', method: 'GET', authRequired: true },
    awardAchievement: { path: '/api/gamification/achievements/award', method: 'POST', authRequired: true },
    getUserProgress: { path: '/api/gamification/levels/progress', method: 'GET', authRequired: true },
    getUserProgressById: { path: '/api/gamification/levels/progress/:id', method: 'GET', authRequired: true },
    getLeaderboard: { path: '/api/gamification/levels/leaderboard', method: 'GET', authRequired: true },
    getLevelDefinitions: { path: '/api/gamification/levels/definitions', method: 'GET', authRequired: true },
    getCurrentLevel: { path: '/api/gamification/levels/current', method: 'GET', authRequired: true },
    getNextLevel: { path: '/api/gamification/levels/next', method: 'GET', authRequired: true },
    addPoints: { path: '/api/gamification/levels/points', method: 'POST', authRequired: true },
  },

  // Manage products
  manageProducts: {
    getCategories: { path: '/api/manage/categories', method: 'GET', authRequired: true },
    createCategory: { path: '/api/manage/categories', method: 'POST', authRequired: true },
    updateCategory: { path: '/api/manage/categories/:id', method: 'PUT', authRequired: true },
    deleteCategory: { path: '/api/manage/categories/:id', method: 'DELETE', authRequired: true },
    getProducts: { path: '/api/manage/products', method: 'GET', authRequired: true },
    getProduct: { path: '/api/manage/products/:id', method: 'GET', authRequired: true },
    createProduct: { path: '/api/manage/products', method: 'POST', authRequired: true },
    updateProduct: { path: '/api/manage/products/:id', method: 'PUT', authRequired: true },
    deleteProduct: { path: '/api/manage/products/:id', method: 'DELETE', authRequired: true },
    updateProductMediaOrder: { path: '/api/manage/products/:id/media', method: 'PUT', authRequired: true },
    getProductPricing: { path: '/api/manage/products/:id/pricing', method: 'GET', authRequired: true },
    createProductPrice: { path: '/api/manage/products/:id/pricing', method: 'POST', authRequired: true },
    updateProductPrice: { path: '/api/manage/products/:id/pricing/:priceId', method: 'PUT', authRequired: true },
    deleteProductPrice: { path: '/api/manage/products/:id/pricing/:priceId', method: 'DELETE', authRequired: true },
    getBulkPricingRules: { path: '/api/manage/pricing/bulk', method: 'GET', authRequired: true },
    createBulkPricingRule: { path: '/api/manage/pricing/bulk', method: 'POST', authRequired: true },
    getExchangeRates: { path: '/api/manage/exchange-rates', method: 'GET', authRequired: true },
    updateExchangeRate: { path: '/api/manage/exchange-rates/:currencyTo', method: 'PUT', authRequired: true },
    updateExchangeRates: { path: '/api/manage/exchange-rates/sync', method: 'POST', authRequired: true },
    syncPricesWithStripe: { path: '/api/manage/pricing/stripe/sync', method: 'POST', authRequired: true },
  },

  // Media
  media: {
    getMediaItems: { path: '/api/pub/media/GetWhere', method: 'GET', authRequired: true },
    uploadMedia: { path: '/api/system/media/upload', method: 'POST', authRequired: true },
    updateMediaMetadata: { path: '/api/system/media/:id', method: 'PUT', authRequired: true },
    updateSequence: { path: '/api/system/media/:id/sequence', method: 'PUT', authRequired: true },
    deleteMedia: { path: '/api/system/media/:id', method: 'DELETE', authRequired: true },
  },

  // Circle of Trust routes
  circleOfTrust: {
    // Circle Management
    createCircle: { path: '/api/user/circleOfTrust/circle', method: 'POST', authRequired: true },
    updateCircle: { path: '/api/user/circleOfTrust/circle/:circleId', method: 'PUT', authRequired: true },
    deleteCircle: { path: '/api/user/circleOfTrust/circle/:circleId', method: 'DELETE', authRequired: true },
    getTrustCircles: { path: '/api/user/circleOfTrust', method: 'GET', authRequired: true },

    // Member Management
    removeMember: { path: '/api/user/circleOfTrust/circle/:circleId/member/:userId', method: 'DELETE', authRequired: true },
    updateMemberRole: { path: '/api/user/circleOfTrust/circle/:circleId/member/:userId/role', method: 'PUT', authRequired: true },

    // Invitation Management
    getInvitationsSent: { path: '/api/user/circleOfTrust/invitation/sent', method: 'GET', authRequired: true },
    getInvitationsReceived: { path: '/api/user/circleOfTrust/invitation/received', method: 'GET', authRequired: true },
    createInvitation: { path: '/api/user/circleOfTrust/invitation/create', method: 'POST', authRequired: true },
    renewInvitation: { path: '/api/user/circleOfTrust/invitation/renew', method: 'POST', authRequired: true },
    cancelInvitation: { path: '/api/user/circleOfTrust/invitation/:token', method: 'DELETE', authRequired: true },
    acceptInvitation: { path: '/api/user/circleOfTrust/invitation/accept', method: 'POST', authRequired: true },
    declineInvitation: { path: '/api/user/circleOfTrust/invitation/decline', method: 'POST', authRequired: true },

    // Quota Management
    getQuota: { path: '/api/user/circleOfTrust/quota', method: 'GET', authRequired: true }
  },

  // Share & API Key routes
  share: {
    getSiteApiKeys: { path: '/api/user/sites/:siteId/api-keys', method: 'GET', authRequired: true },
    createSiteApiKey: { path: '/api/user/sites/:siteId/api-keys', method: 'POST', authRequired: true },
    revokeSiteApiKey: { path: '/api/user/sites/:siteId/api-keys/:keyId', method: 'DELETE', authRequired: true },
    getSiteShared: { path: '/api/user/sites/:siteId/shared', method: 'GET', authRequired: true },
    convertSharedToPost: { path: '/api/user/sites/:siteId/shared/:articleId/convert', method: 'POST', authRequired: true },
    discardShared: { path: '/api/user/sites/:siteId/shared/:articleId/discard', method: 'POST', authRequired: true },
    submitShare: { path: '/api/user/sites/:siteId/share', method: 'POST', authRequired: true },
  },

  // Admin service key management
  serviceKeys: {
    list: { path: '/api/admin/service-keys', method: 'GET', authRequired: true },
    create: { path: '/api/admin/service-keys', method: 'POST', authRequired: true },
    revoke: { path: '/api/admin/service-keys/:keyId', method: 'DELETE', authRequired: true },
  },
};

// Helper function to get non-auth required routes
const getNonAuthRequiredRoutes = () => {
  const routes = [];

  // Iterate through all route categories
  Object.values(apiRoutes).forEach(category => {
    // Iterate through all routes in the category
    Object.values(category).forEach(route => {
      if (route.authRequired === false) {
        routes.push(route.path);
      }
    });
  });
  //console.log('getNonAuthRequiredRoutes(): routes: ', routes);
  return routes;
};

// Helper function to get a route with parameters replaced
const getRoute = (routePath, params = {}) => {
  let path = routePath;

  // Replace path parameters
  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, value);
  });

  return path;
};

// User Accounts Admin endpoints
export const ADMIN_USER_ACCOUNTS_SEARCH = '/api/admin/userAccounts/search';
export const ADMIN_USER_ACCOUNTS_PAGINATED = '/api/admin/userAccounts/paginated';
export const ADMIN_USER_ACCOUNTS_BY_ID = '/api/admin/userAccounts/:id';
export const ADMIN_USER_ACCOUNTS_PASSWORD_RESET = '/api/admin/userAccounts/:id/password-reset';
export const ADMIN_USER_ACCOUNTS_ROLE = '/api/admin/userAccounts/:id/role';
export const ADMIN_USER_ACCOUNTS_VERIFICATION = '/api/admin/userAccounts/:id/verification-status';
export const ADMIN_USER_ACCOUNTS_DELETION = '/api/admin/userAccounts/:id/deletion-status';
export const ADMIN_USER_ACCOUNTS_PREFERENCES = '/api/admin/userAccounts/:id/preferences';
export const ADMIN_USER_ACCOUNTS_STATUS = '/api/admin/userAccounts/:id/status';
export const ADMIN_USER_ACCOUNTS_SUBSCRIPTION = '/api/admin/userAccounts/:id/subscription';
export const ADMIN_USER_ACCOUNTS_ENTITLEMENT = '/api/admin/userAccounts/:id/entitlement';
export const ADMIN_USER_ACCOUNTS_GAMIFICATION = '/api/admin/userAccounts/:id/gamification';
export const ADMIN_USER_ACCOUNTS_SECURITY = '/api/admin/userAccounts/:id/security';
export const ADMIN_USER_ACCOUNTS_INVALIDATE_TOKENS = '/api/admin/userAccounts/:id/invalidate-tokens';
export const ADMIN_USER_ACCOUNTS_LOGIN_HISTORY = '/api/admin/userAccounts/:id/login-history';
export const ADMIN_USER_ACCOUNTS_ROLES_REALMS = '/api/admin/userAccounts/:id/roles-and-realms';
export const ADMIN_USER_ACCOUNTS_CIRCLE_OF_TRUST = '/api/admin/userAccounts/:id/circle-of-trust';
export const ADMIN_USER_ACCOUNTS_AI_USAGE = '/api/admin/userAccounts/:id/ai-usage';
export const ADMIN_USER_ACCOUNTS_ASSETS = '/api/admin/userAccounts/:id/assets';
export const ADMIN_USER_ACCOUNTS_AUDIO_FILES = '/api/admin/userAccounts/:id/audio-files';
export const ADMIN_USER_ACCOUNTS_ORDERS = '/api/admin/userAccounts/:id/orders';
export const ADMIN_USER_ACCOUNTS_EXPORT = '/api/admin/userAccounts/:id/export';
export const ADMIN_USER_ACCOUNTS_PURGE = '/api/admin/userAccounts/:id/purge';

export { baseURL, defaultConfig, apiRoutes, getNonAuthRequiredRoutes, getRoute }; 